"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SATU_COOKIE_NAME = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var uuid_1 = require("uuid"); // 2 years in days
var SATU_COOKIE_LIFETIME = 2 * 365;
exports.SATU_COOKIE_NAME = '_satu';
var SatuCookieHelper = /** @class */ (function () {
    function SatuCookieHelper() {
    }
    SatuCookieHelper.init = function (options) {
        this.cookieDomain = options.domain;
    };
    SatuCookieHelper.hasSatuId = function () {
        return js_cookie_1.default.get(this.cookieName) !== undefined;
    };
    SatuCookieHelper.getSatuId = function () {
        if (!this.hasSatuId()) {
            this.setSatuId((0, uuid_1.v4)());
        }
        return js_cookie_1.default.get(this.cookieName);
    };
    SatuCookieHelper.setSatuId = function (satuId) {
        var options = { expires: this.cookieLifetime };
        if (this.cookieDomain) {
            options.domain = this.cookieDomain;
        }
        js_cookie_1.default.set(this.cookieName, satuId, options);
    };
    SatuCookieHelper.cookieName = exports.SATU_COOKIE_NAME;
    SatuCookieHelper.cookieLifetime = SATU_COOKIE_LIFETIME;
    return SatuCookieHelper;
}());
exports.default = SatuCookieHelper;
//# sourceMappingURL=satu-cookie-helper.js.map